import type { AxiosInstance } from 'axios';

import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';

export const client: AxiosInstance = axios.create({
  baseURL: '/',
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json, application/octet-stream',
  },
  timeout: 60 * 1000,
  validateStatus(status) {
    return status >= 200 && status < 300 || status === 304
  },

});

client.interceptors.request.use(
    (config) => {
      if (config?.headers) {
        config.headers['X-Request-ID'] = uuidv4()
      }
      return config
    },
    (error) => Promise.reject(error)
  )

client.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && typeof window !== 'undefined') {
      const onLogoutRoute = window.location.pathname.startsWith('/auth/');
      if (!onLogoutRoute) {
        window.location.href = '/auth/logout';
      }
    }
    return Promise.reject(error);
  }
)
